export const env = {
  apiBaseUrl:
    import.meta.env.VITE_API_BASE_URL || 'https://api.ads.innolabs.agency/api/v1/admin',
} as const
